import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { userLogin } from '../features/auth/authSlice'
import Spinner from '../components/Spinner'
import  Error  from '../components/Error'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const LoginScreen = () => {
  const { register, handleSubmit, formState:{errors} } = useForm({shouldUseNativeValidation: true})
  const { loading, error, userInfo } = useSelector((state) => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submitForm = (data) => {
    // console.log(data)
    dispatch(userLogin(data));
  }

  useEffect(() => {
    if (userInfo){
      navigate('/chat')
      // navigate('/user-profile')
    }
  }, [navigate, userInfo])

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      {error === "Invalid credentials" && <Error>{error}</Error>}
      <div className='form-group '>
        <label className='text-[var(--text-white)]' htmlFor='username'>Username</label>
        <input
          type='text'
          className='form-input'
          {...register('username',{ 
            required: "Username is required",
            /* pattern:{
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address'
            }, */
          })}
          /* required */
        />
      </div>
      <div className='form-group'>
        <label className='text-[var(--text-white)]' htmlFor='password'>Password</label>
        <input
          type='password'
          className='form-input'
          {...register('password')}
          required
        />
      </div>
      <button type='submit' className='button'>
        {loading ? <Spinner /> : "Login"}
      </button>
       
    </form>
  )
}

export default LoginScreen
